<template>
  <div>
    <v-file-input multiple show-size label="Bilder auswählen" v-model="files" />
    <v-btn :disabled="!files || !files.length" color="primary" :loading="loading" @click="upload">Hochladen</v-btn>
  </div>
</template>

<script>
import api from "@/api"
export default {
  props: ["albumId"],
  data() {
    return { files: [], loading: false }
  },
  methods: {
    async upload() {
      if (!this.files.length) return
      this.loading = true
      await api.display.uploadPhotos(this.albumId, this.files)
      this.loading = false
      this.files = []
      this.$emit("uploaded")
      this.$emit("refresh")
    },
  },
}
</script>
